import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


interface LoaderStatus {
  loading?: boolean;
  error?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PulseLoaderService {
  private status = new Subject<LoaderStatus>();

  get loading$() {
    return this.status.asObservable();
  }

  private loading(value?: LoaderStatus) {
    return this.status.next({ loading: true, ...value })
  }

  public error(): Promise<void> {
    this.show({ error: true })
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 1000);
    })
  }

  public show(status?: LoaderStatus) {
    this.loading({ error: false, ...status })
  }

  public hide() {
    return this.loading({ loading: false })
  }
}
